import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: '🛡️',
    title: 'Módulo 1 — El Escudo Anti-Explosión',
    desc: 'Protocolo de 60 segundos, Sistema Semáforo y las frases exactas para bajar la temperatura cuando tu hijo está en rojo total.'
  }, {
    icon: '🚨',
    title: 'Módulo 2 — Rescate Ansiedad 911',
    desc: '15 técnicas físicas para frenar ataques de pánico, parálisis por exámenes y el loop de pensamientos que no para.'
  }, {
    icon: '📓',
    title: 'Módulo 3 — El Diario Silencioso',
    desc: 'Hojas de trabajo con disparadores visuales para que exprese lo que no puede decir en voz alta. Sin presión. Sin sermón.'
  }, {
    icon: '⭐',
    title: 'Módulo 4 — Blindaje de Autoestima',
    desc: 'Actividades para separar su valor real de la validación externa y construir autoconfianza desde adentro.'
  }, {
    icon: '🤝',
    title: 'Módulo 5 — Protocolo Sin Palabras',
    desc: 'Señales, tarjetas y códigos para comunicar necesidades sin hablar cuando las palabras generan más explosión.'
  }, {
    icon: '📅',
    title: 'Módulo 6 — Plan de Reconexión 30 Días',
    desc: 'Micro-acciones diarias de 2 minutos para fortalecer la confianza sin que parezcan tareas ni obligaciones.'
  }];
  const includes = ['Protocolo paso a paso listo para aplicar hoy', 'Fichas imprimibles y completables', 'Frases exactas para cada situación', 'Ejemplos reales de familias argentinas', 'Checklist de seguimiento semanal', 'Guía para el padre/madre de cómo entregarlo', 'Señales de alarma y cuándo buscar ayuda profesional', '100% en español rioplatense'];
  return <section className="py-24 bg-surface border-y border-white/5" data-id="element-152">
      <div className="container mx-auto px-4" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="text-center mb-16" data-id="element-155">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-156">
              🏆 KIT ADULTO DE RESCATE
            </h2>
            <p className="text-xl text-gold font-medium" data-id="element-157">
              6 Módulos + 4 Bonos — 13 a 18 años
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-158">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-159">
              <div className="bg-background p-8 rounded-2xl border border-white/10 hover:border-gold/50 transition-colors group h-full" data-id="element-160">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-161">
                  {mod.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-162">
                  {mod.title}
                </h3>
                <p className="text-gray-400" data-id="element-163">{mod.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-164">
          <div className="bg-background/50 p-8 rounded-2xl border border-white/5 max-w-4xl mx-auto" data-id="element-165">
            <h4 className="text-center text-lg text-gray-300 mb-6 font-medium" data-id="element-166">
              Cada módulo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-167">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-168">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-169" />
                  <span className="text-gray-200" data-id="element-170">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}